//
//
//
//

import PageUiMenu from '@/components/PageUi/Menu'
import PageFooter from '@/components/PageFooter'
import CanvasPanel from '@/components/CanvasPanel'

export default {
  name: 'ViewerCanvasPanel',
  components: { 
    PageFooter, 
    PageUiMenu, 
    CanvasPanel
  },
  data () {
    return {
      // 'https://stephenwf.github.io/ocean-liners.json'
      manifest: this.$route.query.iiif || 'https://stephenwf.github.io/ocean-liners.json',
      title: this.$route.query.title || 'title'
    }
  },
  created() {
  },
  mounted() {
  }
}
